const flutterBuy = {
  en: {
    flutterBuy: {
      title: 'Purchase a policy',
      'cat1.title': 'Insurance of motor vehicles',
      'cat1.item1.name': 'CICL VO',
      'cat1.item1.description': 'Compulsory motor insurance',
      'cat1.item2.name': 'Voluntary motor third party liability insurance',
      'cat1.item2.description':
        'The policy will protect you from unexpected expenses up to the amount of your choice.',
      'cat1.item3.name': 'CASCO',
      'cat1.item3.description': 'CASCO Car insurance',
      'cat1.item4.name': "Carrier's liability to passengers",
      'cat1.item4.description':
        'Compensation for damage caused to the life, health and/or property of passengers during their carriage',
      'cat2.title': 'Travel',
      'cat2.item1.name': 'Abroad',
      'cat2.item1.description': 'Insurance for traveling abroad',
      'cat3.title': 'Property',
      'cat3.item1.name': 'House/Apartment',
      'cat3.item1.description': 'Property Damage insurance',
      'cat3.item2.name': 'Liability towards neighbours',
      'cat3.item2.description':
        'Compensate for damage to neighbours. Restore their repairs and property',
      'cat4.title': 'Health',
      'cat4.item1.name': 'Accident insurance',
      'cat4.item1.description': 'Disability, disability, death',
      'cat4.item2.name': "Sportsman's insurance",
      'cat4.item2.description': "Sportsman's Insurance Program",
      'cat4.item3.name': 'Medical insurance for non-residents',
      'cat4.item3.description':
        'Foreign employees, business immigrants, labour migrants',
      'cat4.item4.name': 'Accident insurance for children',
      'cat4.item4.description': 'Accident Insurance Program for children',
      'description.minutes': 'Processing in 3 minutes.',
      'description.competitions': 'Participation in competitions every week',
      buy: 'Purchase',
      online: 'Online',
      offline: 'Application',
      'contacts.title': 'Contacts',
      'contacts.list': 'LIST',
      'contacts.map': 'MAP',
      'contacts.office': 'Head office',
      'contacts.time': 'Opening hours',
    },
  },
  kz: {
    flutterBuy: {
      title: 'Полис сатып алу',
      'cat1.title': 'Автосақтандыру',
      'cat1.item1.name': 'ОГПО ВТС',
      'cat1.item1.description': 'Міндетті авто сақтандыру',
      'cat1.item2.name': 'Автоның ЕАҚМ',
      'cat1.item2.description':
        'Бағдарлама Сізді күтпеген шығындардан, таңдалған сома мөлшерінен қорғайды',
      'cat1.item3.name': 'КАСКО',
      'cat1.item3.description': 'КАСКО автосақтандыру',
      'cat1.item4.name': 'Тасымалдаушының жолаушылар алдындағы жауапкершілігі',
      'cat1.item4.description':
        'Жолаушыларды тасымалдау кезінде олардың өміріне, денсаулығына және (немесе) мүлкіне келтірілген зиянды өтеу',
      'cat2.title': 'Саяхат',
      'cat2.item1.name': 'Шетелге',
      'cat2.item1.description': 'Шетелге шығушыларды сақтандыру',
      'cat3.title': 'Мүлік',
      'cat3.item1.name': 'Пәтер/Үй',
      'cat3.item1.description': 'Мүлікті залалдан сақтандыру',
      'cat3.item2.name': 'Көршілер алдындағы жауапкершілік',
      'cat3.item2.description':
        'Көршілерге келтірілген зиянды өтеу. Мүліктерді жөндеу және қалпына келтіру',
      'cat4.title': 'Денсаулық',
      'cat4.item1.name': 'Жазатайым жағдайдан сақтандыру',
      'cat4.item1.description':
        'Еңбекке жарамсыздығы, мүгедектігі, қайтыс болуы',
      'cat4.item2.name': 'Спортшыларды сақтандыру',
      'cat4.item2.description': 'Спортшыларды сақтандыру бағдарламасы',
      'cat4.item3.name': 'Бейрезиденттерді медициналық сақтандыру',
      'cat4.item3.description':
        'Шетелдік қызметкерлер, бизнес-иммигранттар, еңбек мигранттары',
      'cat4.item4.name': 'Балаларды жазатайым оқиғадан сақтандыру',
      'cat4.item4.description':
        'Балаларды жазатайым оқиғалардан сақтандыру бағдарламасы',
      'description.minutes': '3 минут ішінде рәсімдеу',
      'description.competitions': 'Әр апта сайын байқауларға қатысу',
      buy: 'Сатып алу',
      online: 'Онлайн',
      offline: 'Өтінім',
      'contacts.title': 'Байланыс деректері',
      'contacts.list': 'ТІЗІМ',
      'contacts.map': 'КАРТА',
      'contacts.office': 'Бас кеңсе',
      'contacts.time': 'Жұмыс уақыты',
    },
  },
  ru: {
    flutterBuy: {
      title: 'Купить полис',
      'cat1.title': 'Автострахование',
      'cat1.item1.name': 'ОГПО ВТС',
      'cat1.item1.description': 'Обязательное автострахование',
      'cat1.item2.name': 'ДГПО авто',
      'cat1.item2.description':
        'Программа защитит Вас от непредвиденных расходов, в размере выбранной суммы',
      'cat1.item3.name': 'КАСКО',
      'cat1.item3.description': 'КАСКО автострахование',
      'cat1.item4.name': 'Ответственность перевозчика перед пассажирами',
      'cat1.item4.description':
        'Возмещение вреда причиненного жизни, здоровью и (или) имуществу пассажиров при их перевозке',
      'cat2.title': 'Путешествия',
      'cat2.item1.name': 'За границу',
      'cat2.item1.description': 'Страхование выезжающих за рубеж',
      'cat3.title': 'Имущество',
      'cat3.item1.name': 'Квартира/Дом',
      'cat3.item1.description': 'Страхование имущества от ущерба',
      'cat3.item2.name': 'Ответственность перед соседями',
      'cat3.item2.description':
        'Возместить ущерб соседям. Восстановить их ремонт и имущество',
      'cat4.title': 'Здоровье',
      'cat4.item1.name': 'Страхование от несчастного случая',
      'cat4.item1.description': 'Утрата трудоспособности, инвалидность, смерть',
      'cat4.item2.name': 'Страхование спортсменов',
      'cat4.item2.description': 'Программа страхования спортсменов',
      'cat4.item3.name': 'Медицинское страхование нерезидентов',
      'cat4.item3.description':
        'Иностранные работники, бизнес-иммигранты, трудовые мигранты',
      'cat4.item4.name': 'Страхование детей от несчастного случая',
      'cat4.item4.description':
        'Программа страхования детей от несчастных случаев',
      'description.minutes': 'Оформление за 3 минуты',
      'description.competitions': 'Участие в конкурсах каждую неделю',
      buy: 'Купить',
      online: 'Онлайн',
      offline: 'Заявка',
      'contacts.title': 'Контакты',
      'contacts.list': 'СПИСОК',
      'contacts.map': 'КАРТА',
      'contacts.office': 'Головной офис',
      'contacts.time': 'Время работы',
    },
  },
};

export default flutterBuy;
